export default __webpack_public_path__ + "media/images/dashboard_icons/pen-ruler-6d53dd4085f0984be8fbb047748afe1c.svg";